<template>
  <v-select
    class="forms-query-select"
    :options="options"
    :placeholder="placeholder"
    :disabled="disabled"
    :filterable="false"
    :value="selectedOption"
    :loading="loading && open"
    :clearable="false"
    @search="search"
    @input="emitInput"
    @open="onOpen"
    @close="open = false"
  >
    <template #no-options>
      <div class="forms-query-select__option-details">
        <template v-if="!q || q.length < minSearchLength">
          {{ $t("components.forms.query_select.start_search") }}
        </template>
        <template v-else>
          {{ $t("components.forms.query_select.no_results") }}
        </template>
      </div>
    </template>

    <template #option="option">
      <div class="forms-query-select__option">
        <div class="forms-query-select__option-label">
          {{ option.label }}
        </div>
        <div v-if="option.details" class="forms-query-select__option-details">
          {{ option.details }}
        </div>
      </div>
    </template>
  </v-select>
</template>

<script>
import { debounce } from "@/helpers/debounce";
import vSelect from "vue-select";

export default {
  name: "QuerySelect",
  components: { vSelect },
  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    name: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      required: false,
      default: undefined,
    },
    searchFct: {
      type: Function,
      required: false,
      default: () => {},
    },
    minSearchLength: {
      type: Number,
      default: 3,
    },
  },
  data() {
    return {
      q: "",
      loading: false,
      open: false,
      options: [],
      selectedOption: null,
    };
  },
  computed: {
    debouncedSearchFct() {
      return debounce(async () => {
        this.options = await this.searchFct(this.q);
      });
    },
  },
  methods: {
    emitInput(value) {
      this.selectedOption = value;

      this.$emit("input", value);
    },
    search(q) {
      this.q = q;

      if (this.open) {
        if (this.q && this.q.length >= this.minSearchLength) {
          try {
            this.loading = true;

            this.debouncedSearchFct();

            this.loading = false;
          } finally {
            this.loading = false;
          }
        } else {
          // Clear options if query is not long enough.
          this.selectedOption = null;
          this.options = [];
        }
      }
    },
    reset() {
      this.q = "";
      this.selectedOption = null;
      this.options = [];

      this.$emit("input", null);
    },
    onOpen() {
      this.open = true;
    },
  },
};
</script>

<style lang="scss">
.forms-query-select {
  background: $white;

  &__option-details {
    font-size: 0.8125rem;
    color: $content-neutral-secondary;
  }
  /* Highlit option */
  .vs__dropdown-option--highlight {
    background: $locomotion-green;

    .forms-query-select__option-details {
      color: $white;
    }
  }
}
</style>
